import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import {
  useGetUsersByAccountAndSoftwareQuery,
  useGetWriteOffStatusListingLazyQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { WriteOffDisposalPostingList } from './WriteOffDisposalList/WriteOffDisposalPostingList'
import { WODisposalEntryList } from './WriteOffDisposalList/WODisposalEntryList'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'

export const WriteOffDisposalMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const approvalStatusEnum = [
    { name: 'Draft', ID: 'ACTIVE' },
    { name: 'Submitted', ID: 'SUBMIT' },
    { name: 'Approved', ID: 'COMPLETED' },
    { name: 'Rejected', ID: 'REJECTED' },
    { name: 'All', ID: 'ALL' },
  ]

  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [TotalLength, setTotalLength] = useState(0)
  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'ACTIVE'
  )

  const [
    loadAsset,
    { loading: AssetLoading, data: AssetData, fetchMore },
  ] = useGetWriteOffStatusListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getWriteOffStatusListing }) => {
      if (getWriteOffStatusListing?.Data?.length > 0) {
        setOriginalListing([...filteredList, ...getWriteOffStatusListing?.Data])
      }

      setTotalLength(getWriteOffStatusListing?.TotalLength)
    },
  })

  useEffect(() => {
    setOriginalListing([])
    loadAsset({
      variables: {
        CompanyID: CompanyID,
        StatusArr:
          listStatus === 'ALL'
            ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
            : [listStatus],
        take: 30,
        skip: 0,
        searchValue: getSearch?.name || undefined,
      },
    })
  }, [listStatus, CompanyID])

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({ fetchPolicy: 'network-only' })

  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()

  const [timer, setTimer] = useState(null)
  function changeDelay(searchValue) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadAsset({
          variables: {
            CompanyID: CompanyID,
            StatusArr:
              listStatus === 'ALL'
                ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
                : [listStatus],
            take: 30,
            skip: 0,
            searchValue: searchValue || undefined,
          },
        })
      }, 1000)
    )
  }

  const hasChanges = () => {
    if (postIDs?.size === 0) return false
    else return true
  }

  return (
    <>
      {(UserLoading || AssetLoading) && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true && listStatus === 'SUBMIT'
            ? setOpenExitConf(true)
            : history.push(`/fixed-assets/${CompanyID}`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Write Off / Disposal', current: true },
        ]}
      />

      <div className="search-filter with-dropdown-filter ">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            changeDelay(e?.target?.value)
            localStorage.setItem(
              'searchFilter',
              JSON.stringify({
                option: listStatus ?? 'ACTIVE',
                name: e?.target?.value,
              })
            )
          }}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            loadAsset({
              variables: {
                CompanyID: CompanyID,
                StatusArr:
                  listStatus === 'ALL'
                    ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
                    : [listStatus],
                take: 30,
                skip: 0,
              },
            })
          }}
          isDefaultValue={!!getSearch?.name}
        />

        <DropdownBar
          options={approvalStatusEnum}
          setOptionID={setListStatus}
          borderRadius="4px"
          defaultOption={approvalStatusEnum
            ?.map(opt => opt?.ID)
            .indexOf(listStatus ?? 'ACTIVE')}
          searchFilter={getSearch}
        />
      </div>

      {(listStatus === 'ACTIVE' ||
        listStatus === 'COMPLETED' ||
        listStatus === 'ALL' ||
        listStatus === 'REJECTED') && (
        <WODisposalEntryList
          filteredList={filteredList?.length > 0 ? filteredList : originalList}
          listLoading={AssetLoading}
          listStatus={listStatus}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
          fetchMore={loadAsset}
          hasMore={originalList?.length < TotalLength}
        />
      )}

      {listStatus === 'SUBMIT' && (
        <WriteOffDisposalPostingList
          filteredList={filteredList?.length > 0 ? filteredList : originalList}
          listLoading={AssetLoading}
          listStatus={listStatus}
          postIDs={postIDs}
          setPostIDs={setPostIDs}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
          fetchMore={loadAsset}
          CompanyID={CompanyID}
        />
      )}

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/fixed-assets/${CompanyID}`)
        }}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error'}
      />
    </>
  )
}
